// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container{
  width: 100%;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-20{
  bottom: -5rem;
}
.-left-20{
  left: -5rem;
}
.-right-20{
  right: -5rem;
}
.-top-20{
  top: -5rem;
}
.bottom-0{
  bottom: 0px;
}
.left-0{
  left: 0px;
}
.left-3{
  left: 0.75rem;
}
.right-0{
  right: 0px;
}
.right-3{
  right: 0.75rem;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.z-10{
  z-index: 10;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.m-1{
  margin: 0.25rem;
}
.m-2{
  margin: 0.5rem;
}
.m-3{
  margin: 0.75rem;
}
.m-6{
  margin: 1.5rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.\\!mr-1{
  margin-right: 0.25rem !important;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-96{
  margin-bottom: 24rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.block{
  display: block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.size-4{
  width: 1rem;
  height: 1rem;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-2{
  height: 0.5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-8{
  height: 2rem;
}
.h-\\[calc\\(100\\%-180px\\)\\]{
  height: calc(100% - 180px);
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.max-h-60{
  max-height: 15rem;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1\\/2{
  width: 50%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\/12{
  width: 16.666667%;
}
.w-24{
  width: 6rem;
}
.w-3{
  width: 0.75rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/12{
  width: 33.333333%;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-8{
  width: 2rem;
}
.w-full{
  width: 100%;
}
.max-w-md{
  max-width: 28rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.border-collapse{
  border-collapse: collapse;
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping{
  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-grab{
  cursor: grab;
}
.cursor-grabbing{
  cursor: grabbing;
}
.cursor-pointer{
  cursor: pointer;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-2{
  gap: 0.5rem;
}
.gap-4{
  gap: 1rem;
}
.gap-6{
  gap: 1.5rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-x-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 1;
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r-4{
  border-right-width: 4px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-600{
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-900{
  --tw-border-opacity: 1;
  border-color: rgb(49 46 129 / var(--tw-border-opacity, 1));
}
.border-red-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-yellow-500{
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.border-opacity-30{
  --tw-border-opacity: 0.3;
}
.\\!bg-indigo-700{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1)) !important;
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-200{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-200{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-indigo-700{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.bg-indigo-900\\/90{
  background-color: rgb(49 46 129 / 0.9);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l{
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-amber-500{
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50{
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-400{
  --tw-gradient-from: #4ade80 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(74 222 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600{
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600{
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-900{
  --tw-gradient-from: #312e81 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-100{
  --tw-gradient-from: #f3e8ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 232 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-400{
  --tw-gradient-from: #f87171 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 113 113 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-600{
  --tw-gradient-from: #0d9488 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(13 148 136 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-400{
  --tw-gradient-from: #facc15 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 204 21 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-green-500{
  --tw-gradient-to: #22c55e var(--tw-gradient-to-position);
}
.to-green-600{
  --tw-gradient-to: #16a34a var(--tw-gradient-to-position);
}
.to-indigo-100{
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
.to-indigo-500{
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-orange-600{
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}
.to-purple-600{
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-purple-900{
  --tw-gradient-to: #581c87 var(--tw-gradient-to-position);
}
.to-red-600{
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}
.to-yellow-600{
  --tw-gradient-to: #ca8a04 var(--tw-gradient-to-position);
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pl-4{
  padding-left: 1rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-start{
  text-align: start;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.\\!text-blue-200{
  --tw-text-opacity: 1 !important;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-blue-600{
  --tw-text-opacity: 1 !important;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.opacity-50{
  opacity: 0.5;
}
.opacity-70{
  opacity: 0.7;
}
.mix-blend-multiply{
  mix-blend-mode: multiply;
}
.\\!shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25) !important;
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.blur-xl{
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-lg{
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  direction: rtl;
}

ul,
li {
  list-style: none;
}

.custom-img {
  object-fit: contain;
  width: 100% !important;
  position: relative !important;
  height: unset !important;
}

.unset-img {
  width: 100%;
}

.unset-img > div {
  position: unset !important;
}

img,
video {
  max-width: 100%;
}

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  vertical-align: middle;
}

a {
  color: inherit;
  text-decoration: none;
}

.font-bold {
  font-weight: 700;
}

.font-small {
  font-size: 0.8em;
}

.font-big {
  font-size: 1.2em;
}

.max-w-container {
  max-width: 1366px;
}

.bd-10 {
  border-radius: 10px;
}

.shadowBox {
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
}

.shadowBoxInset {
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15) inset;
}

*:focus {
  outline: none;
}

.select_box {
  width: 200px;
  overflow: hidden;
  border: 1px solid #000;
  position: relative;
  padding: 10px 0;
}

.select_box:after {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #f00;
  position: absolute;
  top: 40%;
  right: 5px;
  content: "";
  z-index: 98;
}

.select_box select {
  width: 220px;
  border: 0;
  position: relative;
  z-index: 99;
  background: none;
}

.radio {
  display: inline-block;
  position: relative;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 24px;
}
.radio__input {
  position: absolute;
  top: 4px;
  left: 0;
  width: 36px;
  height: 20px;
  opacity: 0;
  z-index: 0;
}
.radio__label {
  display: block;
  padding: 0 0 0 24px;
  cursor: pointer;
}
.radio__label:before {
  content: "";
  position: absolute;
  top: 4px;
  left: 0;
  width: 16px;
  height: 16px;
  background-color: transparent;
  border: 2px solid #9e9e9e;
  border-radius: 14px;
  z-index: 1;
  transition: border-color 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}
.radio__label:after {
  content: "";
  position: absolute;
  top: 8px;
  left: 4px;
  width: 8px;
  height: 8px;
  background-color: #3040e6;
  border-radius: 50%;
  z-index: 2;
  transform: scale(0, 0);
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}
.radio__input:checked + .radio__label:before {
  border-color: #3040e6;
}
.radio__input:checked + .radio__label:after {
  transform: scale(1, 1);
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #0666e5 #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 10px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #0666e5;
  border-radius: 10px;
  border: 3px solid #ffffff;
}

.text-center {
  text-align: center;
}

.w-50 {
  width: 50%;
}

.w-25 {
  width: 25%;
}

.w-75 {
  width: 75%;
}

.border-none {
  border: none;
}

.rmdp-container {
  width: 100%;
}

.react-flow__node-PositionNode {
  width: auto !important;
}

.gray-clr {
  color: #9e9e9e;
}

.white-clr {
  color: white;
}

.main-clr {
  color: #3040e6;
}

.main-disabled-clr {
  color: #a1a6e2;
}

.main-low-clr {
  color: #e8eafd;
}

.bg-low-clr {
  color: #f2f3ff;
}

.green-clr {
  color: #0da717;
}

.green-low-clr {
  color: #cffad6;
}

.red-clr {
  color: #db0000;
}

.yellow-clr {
  color: #ffbf00;
}

.red-low-clr {
  color: #fbe5e5;
}

.green-low-clr {
  color: #cffad6;
}

.black-clr {
  color: black;
}

.black-bg {
  background-color: black;
}

.gray-clr-bg {
  background-color: #9e9e9e;
}

.main-clr-bg {
  background-color: #3040e6;
}

.main-disabled-clr-bg {
  background-color: #a1a6e2;
}

.main-low-clr-bg {
  background-color: #e8eafd;
}

.bg-low-clr-bg {
  background-color: #f2f3ff;
}

.green-clr-bg {
  background-color: #0da717;
}

.green-low-clr-bg {
  background-color: #cffad6;
}

.red-clr-bg {
  background-color: #db0000;
}

.red-low-clr-bg {
  background-color: #fbe5e5;
}

.green-low-clr-bg {
  background-color: #cffad6;
}

.white-clr-bg {
  background-color: white;
}

.yellow-clr-bg {
  background-color: #ffbf00;
}

:root {
  --background: #1a1a2e;
  --color: #ffffff;
  --primary-color: #0f3460;
}

.login a {
  text-decoration: none;
  color: var(--color);
}
.login h1 {
  font-size: 2.5rem;
}
.login .container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.login .login-container {
  position: relative;
  width: 22.2rem;
}
.login .form-container {
  border: 1px solid hsla(0, 0%, 65%, 0.158);
  box-shadow: 0 0 36px 1px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  backdrop-filter: blur(20px);
  z-index: 99;
  padding: 2rem;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}
.login .login-container form input {
  display: block;
  padding: 14.5px;
  width: 100%;
  margin: 2rem 0;
  color: black;
  outline: none;
  background-color: rgba(145, 145, 145, 0.1215686275);
  border: none;
  border-radius: 5px;
  font-weight: 500;
  letter-spacing: 0.8px;
  font-size: 15px;
  backdrop-filter: blur(15px);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.login .login-container form input:focus {
  box-shadow: 0 0 16px 1px rgba(0, 0, 0, 0.2);
  animation: wobble 0.3s ease-in;
  -webkit-animation: wobble 0.3s ease-in;
}
.login .login-container form button {
  background-color: var(--primary-color);
  color: var(--color);
  display: block;
  padding: 13px;
  border-radius: 5px;
  outline: none;
  font-size: 18px;
  letter-spacing: 1.5px;
  font-weight: bold;
  width: 100%;
  cursor: pointer;
  margin-bottom: 2rem;
  transition: all 0.1s ease-in-out;
  border: none;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -ms-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
}
.login .login-container form button:hover {
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.15);
  transform: scale(1.02);
  -webkit-transform: scale(1.02);
  -moz-transform: scale(1.02);
  -ms-transform: scale(1.02);
  -o-transform: scale(1.02);
}
.login .circle {
  width: 8rem;
  height: 8rem;
  background: var(--primary-color);
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  position: absolute;
}
.login .illustration {
  position: absolute;
  top: -14%;
  right: -2px;
  width: 90%;
}
.login .circle-one {
  top: 0;
  left: 0;
  z-index: -1;
  transform: translate(-45%, -45%);
  -webkit-transform: translate(-45%, -45%);
  -moz-transform: translate(-45%, -45%);
  -ms-transform: translate(-45%, -45%);
  -o-transform: translate(-45%, -45%);
}
.login .circle-two {
  bottom: 0;
  right: 0;
  z-index: -1;
  transform: translate(45%, 45%);
  -webkit-transform: translate(45%, 45%);
  -moz-transform: translate(45%, 45%);
  -ms-transform: translate(45%, 45%);
  -o-transform: translate(45%, 45%);
}
.login .register-forget {
  margin: 1rem 0;
  display: flex;
  justify-content: space-between;
}
.login .opacity {
  opacity: 0.6;
}
.login .theme-btn-container {
  position: absolute;
  left: 0;
  bottom: 2rem;
}
.login .theme-btn {
  cursor: pointer;
  transition: all 0.3s ease-in;
}
.login .theme-btn:hover {
  width: 40px !important;
}
@keyframes wobble {
  0% {
    transform: scale(1.025);
    -webkit-transform: scale(1.025);
    -moz-transform: scale(1.025);
    -ms-transform: scale(1.025);
    -o-transform: scale(1.025);
  }
  25% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
  }
  75% {
    transform: scale(1.025);
    -webkit-transform: scale(1.025);
    -moz-transform: scale(1.025);
    -ms-transform: scale(1.025);
    -o-transform: scale(1.025);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
  }
}

@media (max-width: 600px) {
  .login {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .login .circle {
    display: none;
  }
  .login .container {
    width: 80%;
  }
  .login .form-container {
    padding: 1rem;
  }
}
.input {
  background-color: white;
  border: 1px solid #f1f1f1;
  color: black;
  border-radius: 5px;
  box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.04);
  padding: 5px;
}

.input-td {
  display: flex;
  justify-content: center;
}

:root {
  --body-background-color: #e5f4ff;
  --v-progress-left: 50px;
  --v-progress-item-height-width: 12px;
  --v-progress-line-height: 35px;
  --v-progress-line-width: 3px;
  --v-progress-gap: 13px;
  --blue: #0081c9;
  --green: #159895;
  --light-blue: #5bc0f8;
}

/* vertical progress */
.v-progress {
  width: fit-content;
  padding: 10px 0 10px 0;
}

.v-progress ul {
  list-style: none;
}

.v-progress-item {
  position: relative;
  /* left: var(--v-progress-left); */
  margin-left: var(--v-progress-left);
  height: var(--v-progress-item-height-width);
  line-height: var(--v-progress-item-height-width);
  margin-bottom: var(--v-progress-line-height);
  --v-progress-border: 8px;
  display: flex;
  justify-content: flex-end;
}

.v-progress-item:last-child {
  margin-bottom: 0px;
}

.v-progress-item:last-child:after {
  border-left: 0px;
}

.v-progress-item:before {
  content: "";
  display: inline-block;
  position: absolute;
  width: var(--v-progress-item-height-width);
  height: var(--v-progress-item-height-width);
  left: calc(0px - var(--v-progress-left));
  border-radius: 50%;
  background-color: #ccc;
}

.v-progress-item:after {
  content: "";
  display: inline-block;
  position: absolute;
  height: calc(var(--v-progress-line-height) - var(--v-progress-gap));
  top: calc(var(--v-progress-item-height-width) + var(--v-progress-gap) / 2);
  left: calc(0px - var(--v-progress-left) + var(--v-progress-item-height-width) / 2 - var(--v-progress-line-width) / 2);
  border-left: var(--v-progress-line-width) solid #ccc;
}

.v-progress-item.completed:after {
  border-color: var(--light-blue);
}

.v-progress-item.completed:before {
  content: "✔";
  font-size: 11px;
  text-align: center;
  color: white;
  background: var(--light-blue);
  height: calc(var(--v-progress-border) + var(--v-progress-item-height-width));
  width: calc(var(--v-progress-border) + var(--v-progress-item-height-width));
  line-height: calc(var(--v-progress-border) + var(--v-progress-item-height-width));
  left: calc(0px - var(--v-progress-left) - var(--v-progress-border) / 2);
  top: calc(0px - var(--v-progress-border) + var(--v-progress-border) / 2);
}

.v-progress-item.cancel:after {
  border-color: red;
}

.v-progress-item.cancel:before {
  content: "✖";
  font-size: 11px;
  text-align: center;
  color: white;
  background: #ff9f9f;
  height: calc(var(--v-progress-border) + var(--v-progress-item-height-width));
  width: calc(var(--v-progress-border) + var(--v-progress-item-height-width));
  line-height: calc(var(--v-progress-border) + var(--v-progress-item-height-width));
  left: calc(0px - var(--v-progress-left) - var(--v-progress-border) / 2);
  top: calc(0px - var(--v-progress-border) + var(--v-progress-border) / 2);
}

.v-progress-item.inprogress:before {
  background-color: white;
  /*   height: calc(var(--v-progress-border) + var(--v-progress-item-height-width));
    width: calc(var(--v-progress-border) + var(--v-progress-item-height-width)); */
  outline: calc(var(--v-progress-border) / 2) solid var(--blue);
  top: calc(0px - var(--v-progress-border) + var(--v-progress-border));
}

#loader {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #275efe;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  flex-direction: column;
}

.cube-folding {
  width: 50px;
  height: 50px;
  display: inline-block;
  transform: rotate(45deg);
  font-size: 0;
}

.cube-folding span {
  position: relative;
  width: 25px;
  height: 25px;
  transform: scale(1.1);
  display: inline-block;
}

.cube-folding span::before {
  content: "";
  background-color: white;
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  width: 25px;
  height: 25px;
  transform-origin: 100% 100%;
  animation: folding 2.5s infinite linear both;
}

.cube-folding .leaf2 {
  transform: rotateZ(90deg) scale(1.1);
}

.cube-folding .leaf2::before {
  animation-delay: 0.3s;
  background-color: #f2f2f2;
}

.cube-folding .leaf3 {
  transform: rotateZ(270deg) scale(1.1);
}

.cube-folding .leaf3::before {
  animation-delay: 0.9s;
  background-color: #f2f2f2;
}

.cube-folding .leaf4 {
  transform: rotateZ(180deg) scale(1.1);
}

.cube-folding .leaf4::before {
  animation-delay: 0.6s;
  background-color: #e6e6e6;
}
@keyframes folding {
  0%, 10% {
    transform: perspective(140px) rotateX(-180deg);
    -webkit-opacity: 0;
    -moz-opacity: 0;
    opacity: 0;
  }
  25%, 75% {
    transform: perspective(140px) rotateX(0deg);
    -webkit-opacity: 1;
    -moz-opacity: 1;
    opacity: 1;
  }
  90%, 100% {
    transform: perspective(140px) rotateY(180deg);
    -webkit-opacity: 0;
    -moz-opacity: 0;
    opacity: 0;
  }
}
.text-loading {
  margin-top: 50px;
  color: white;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #3040e6;
}

input:focus + .slider {
  box-shadow: 0 0 1px #3040e6;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

#flowTree {
  height: 100vh !important;
}

.edge-custom {
  background-color: #ff8383;
  color: white;
  border: 1px solid red;
  border-radius: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 8px;
}
.edge-custom svg {
  color: red;
  margin-left: 5px;
}

.positionNode {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  background-color: #ffc709;
  border-radius: 15px;
  padding: 10px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
}
.positionNode .positionNode-label {
  color: #321515;
}
.positionNode .positionNode-trash {
  color: #e82703;
  cursor: pointer;
}
.positionNode .positionNode-box-icons {
  display: flex;
  justify-content: space-around;
  width: 100px;
}

.departmentNode {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  background-color: #1736f5;
  border-radius: 15px;
  padding: 10px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.65);
}
.departmentNode .departmentNode-label {
  color: white;
  cursor: pointer;
}
.departmentNode .departmentNode-box-icons {
  display: flex;
  justify-content: space-around;
  width: 100px;
}
.departmentNode .departmentNode-trash {
  color: #e82703;
  cursor: pointer;
}
.departmentNode .departmentNode-department {
  color: white;
  cursor: pointer;
}
.departmentNode .departmentNode-position {
  color: #ffc709;
  cursor: pointer;
}

.axis-flow-btn {
  background-color: white;
  border: 1px solid #cdcdcd;
  border-radius: 10px;
  padding: 5px;
  box-shadow: 0px 0px 5px 0px rgba(90, 90, 90, 0.45);
  margin: 8px;
}

.ReactModal__Overlay {
  background-color: rgba(255, 255, 255, 0) !important;
}

.ReactModalPortal:nth-child(1) {
  background-color: rgba(255, 255, 255, 0) !important;
}

.modal-option {
  /* fixed position will always show modal in the top left corner */
  position: fixed;
  top: 0;
  left: 0;
  /* z-index to show modal even if it is used before some other elements */
  z-index: 1000;
  /* make modal fill whole window */
  width: 100vw;
  height: 100vh;
  /* add some background to blur content behind modal */
  background: rgba(255, 255, 255, 0);
  backdrop-filter: blur(10px);
  /* center content inside modal */
  display: flex;
  justify-content: center;
  align-items: center;
}

.compoenent-modal-option {
  background-color: black;
  border: 1px solid gold;
  border-radius: 20px;
  max-width: 1366px;
  width: 50%;
}

.modal-option-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 20px;
}
.modal-option-topbar h1 {
  font-size: 1.1em;
}
.modal-option-topbar svg {
  color: #6800ff;
  font-size: 2em;
}

.modal-content {
  padding: 20px;
}

.box-input-form-modal-content-100 {
  width: 100%;
  display: flex;
  margin-bottom: 15px;
}
.box-input-form-modal-content-100 input {
  width: 100%;
  margin-right: 10px;
  margin-left: 10px;
  background-color: transparent;
  border: 1px solid gold;
  border-radius: 10px;
  padding: 7px;
}

.container-box-input-form-modal-content-50 {
  display: flex;
}

.container-box-input-form-modal-content-30 {
  display: flex;
  justify-content: space-between;
}

.box-input-form-modal-content-50 {
  width: 50%;
  padding-right: 10px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.box-input-form-modal-content-50 input {
  width: 92%;
  background-color: transparent;
  border: 1px solid gold;
  border-radius: 10px;
  height: 38px;
  padding: 7px;
}
.box-input-form-modal-content-50 button {
  width: 92%;
}

.box-input-form-modal-content-30 {
  width: 30%;
  padding-right: 10px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.box-input-form-modal-content-30 input {
  width: 92%;
  background-color: transparent;
  border: 1px solid gold;
  border-radius: 10px;
  height: 38px;
  padding: 7px;
}
.box-input-form-modal-content-30 button {
  width: 92%;
}

.textareaInputStyle {
  width: 92%;
  background-color: transparent;
  border: 1px solid gold;
  border-radius: 10px;
  height: 38px;
  padding: 7px;
  resize: vertical;
  color: gold;
}

.box-inputs-auto {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.box-input-form-modal-content-auto {
  margin: 10px;
  padding-right: 10px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.box-input-form-modal-content-auto input {
  background-color: transparent;
  border: 1px solid gold;
  border-radius: 10px;
  height: 38px;
  padding: 7px;
}

.btn-modal-option-cancel {
  width: 101%;
  background-color: transparent;
  border: 1px solid gold;
  border-radius: 5px;
  color: gold;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 5px;
}

.btn-modal-option-ok {
  width: 101%;
  background-color: gold;
  border: 1px solid gold;
  border-radius: 5px;
  color: black;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 5px;
}

.btn-modal-50 {
  width: 92%;
  background-color: gold;
  border: 1px solid gold;
  border-radius: 5px;
  color: black;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 5px;
}

.modal-components-background {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

.modal-components-warpper {
  background-color: #f5f3ff;
  border: 1px solid #6c00f3;
  border-radius: 20px;
  max-width: 1366px;
  width: 100%;
  overflow: auto;
  max-height: 80vh;
}

.modal-components-background-content {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media all and (max-width: 1024px) {
  .modal-components-background-content {
    width: 90%;
  }
  .compoenent-modal-option {
    width: 90%;
  }
  .box-input-form-modal-content-50 {
    width: 100%;
  }
  .container-box-input-form-modal-content-50 {
    flex-direction: column;
  }
  .box-input-form-modal-content-30 {
    width: 100%;
  }
  .container-box-input-form-modal-content-30 {
    flex-direction: column;
  }
}
#flowTree {
  height: 100vh;
}
#flowTree * {
  direction: ltr;
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-indigo-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.hover\\:bg-amber-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/5:hover{
  background-color: rgb(255 255 255 / 0.05);
}
.hover\\:bg-gradient-to-r:hover{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.hover\\:from-amber-600:hover{
  --tw-gradient-from: #d97706 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 119 6 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-green-700:hover{
  --tw-gradient-from: #15803d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-indigo-700:hover{
  --tw-gradient-from: #4338ca var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 56 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-purple-100:hover{
  --tw-gradient-from: #f3e8ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 232 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-teal-700:hover{
  --tw-gradient-from: #0f766e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 118 110 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:via-white:hover{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.hover\\:to-green-600:hover{
  --tw-gradient-to: #16a34a var(--tw-gradient-to-position);
}
.hover\\:to-green-700:hover{
  --tw-gradient-to: #15803d var(--tw-gradient-to-position);
}
.hover\\:to-indigo-100:hover{
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
.hover\\:to-orange-700:hover{
  --tw-gradient-to: #c2410c var(--tw-gradient-to-position);
}
.hover\\:to-purple-700:hover{
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}
.hover\\:text-gray-200:hover{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-800:hover{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-900:hover{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-800:hover{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-amber-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-amber-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 158 11 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
@media (min-width: 768px){
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:mb-0{
    margin-bottom: 0px;
  }
  .md\\:mr-4{
    margin-right: 1rem;
  }
  .md\\:mt-0{
    margin-top: 0px;
  }
  .md\\:inline-block{
    display: inline-block;
  }
  .md\\:inline{
    display: inline;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:w-1\\/4{
    width: 25%;
  }
  .md\\:w-64{
    width: 16rem;
  }
  .md\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
}
@media (max-width: 1024px){
  .maxLg\\:left-0{
    left: 0px;
  }
  .maxLg\\:my-2{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .maxLg\\:flex{
    display: flex;
  }
  .maxLg\\:w-full{
    width: 100%;
  }
  .maxLg\\:flex-col{
    flex-direction: column;
  }
}
.rtl\\:space-x-reverse:where([dir="rtl"], [dir="rtl"] *) > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 1;
}`, "",{"version":3,"sources":["webpack://./src/scss/main.scss","webpack://./src/scss/base/general.scss","webpack://./src/scss/variables/colors.scss","webpack://./src/scss/base/color.scss","webpack://./src/scss/page/login.scss","webpack://./src/scss/elements/input.scss","webpack://./src/scss/elements/steps.scss","webpack://./src/scss/elements/loading.scss","webpack://./src/scss/elements/toggleSwitch.scss","webpack://./src/scss/elements/flow.scss","webpack://./src/scss/elements/modal.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;;CAAA;AAAA;;;CAAA;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;EAAA,gBAAA;AAAA;AAAA;;;;;;;;CAAA;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,mBAAA;AAAA;AAAA;;;;;CAAA;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,oBAAA;AAAA;AAAA;;;CAAA;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,aAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,YAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;;CAAA;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,QAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,mBAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2DAAA;EAAA,wEAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,wJAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;ACAA;EACI,sBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;ADGJ;;ACAA;;EAEI,gBAAA;ADGJ;;ACDA;EACI,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,wBAAA;ADIJ;;ACDA;EACI,WAAA;ADIJ;;ACFA;EACI,0BAAA;ADKJ;;ACHA;;EAEI,eAAA;ADMJ;;ACHA;;;;;;;;EAQI,cAAA;EACA,sBAAA;ADMJ;;ACHA;EACI,cAAA;EACA,qBAAA;ADMJ;;ACOA;EACI,gBAAA;ADJJ;;ACOA;EACI,gBAAA;ADJJ;;ACMA;EACI,gBAAA;ADHJ;;ACMA;EACI,iBAAA;ADHJ;;ACQA;EACI,mBAAA;ADLJ;;ACQA;EAGI,+CAAA;ADLJ;;ACOA;EAGI,qDAAA;ADJJ;;ACOA;EACI,aAAA;ADJJ;;ACOA;EACI,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;ADJJ;;ACMA;EACI,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,0BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;ADHJ;;ACKA;EACI,YAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;ADFJ;;ACSA;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ADNJ;ACQI;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;ADNR;ACUI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;ADRR;ACUQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,2DAAA;ADRZ;ACWQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,yBCzKD;ED0KC,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,wDAAA;ADTZ;ACeQ;EACI,qBCpLD;AFuKX;ACgBQ;EACI,sBAAA;ADdZ;;AC2BA,8BAAA;AACA,YAAA;AACA;EACI,qBAAA;EACA,gCAAA;ADxBJ;;AC2BA,6BAAA;AACA;EACI,WAAA;ADxBJ;;AC2BA;EACI,mBAAA;ADxBJ;;AC2BA;EACI,yBAAA;EACA,mBAAA;EACA,yBAAA;ADxBJ;;AC2BA;EACI,kBAAA;ADxBJ;;AC2BA;EACI,UAAA;ADxBJ;;AC0BA;EACI,UAAA;ADvBJ;;ACyBA;EACI,UAAA;ADtBJ;;ACyBA;EACI,YAAA;ADtBJ;;ACyBA;EACI,WAAA;ADtBJ;;ACyBA;EACI,sBAAA;ADtBJ;;AG5NA;EACI,cDQO;AFuNX;;AG7NA;EACI,YAAA;AHgOJ;;AG7NA;EACI,cDRO;AFwOX;;AG7NA;EACI,cDXgB;AF2OpB;;AG7NA;EACI,cDdW;AF8Of;;AG7NA;EACI,cDjBS;AFiPb;;AG7NA;EACI,cDpBQ;AFoPZ;;AG7NA;EACI,cDvBY;AFuPhB;;AG7NA;EACI,cD1BM;AF0PV;;AG9NA;EACI,cD5BS;AF6Pb;;AG9NA;EACI,cD/BU;AFgQd;;AG9NA;EACI,cDtCY;AFuQhB;;AG9NA;EACI,YAAA;AHiOJ;;AG9NA;EACI,uBAAA;AHiOJ;;AG9NA;EACI,yBD9CO;AF+QX;;AG9NA;EACI,yBD3DO;AF4RX;;AG9NA;EACI,yBD9DgB;AF+RpB;;AG9NA;EACI,yBDjEW;AFkSf;;AG9NA;EACI,yBDpES;AFqSb;;AG9NA;EACI,yBDvEQ;AFwSZ;;AG9NA;EACI,yBD1EY;AF2ShB;;AG9NA;EACI,yBD7EM;AF8SV;;AG9NA;EACI,yBD/EU;AFgTd;;AG9NA;EACI,yBDtFY;AFuThB;;AG9NA;EACI,uBAAA;AHiOJ;;AG9NA;EACI,yBD5FS;AF6Tb;;AIpUA;EACI,qBAAA;EACA,gBAAA;EACA,wBAAA;AJuUJ;;AInUI;EACI,qBAAA;EACA,mBAAA;AJsUR;AInUI;EACI,iBAAA;AJqUR;AIlUI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AJoUR;AIjUI;EACI,kBAAA;EACA,cAAA;AJmUR;AIjUI;EACI,yCAAA;EACA,2CAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;AJmUR;AIhUI;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mDAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;AJkUR;AI/TI;EACI,2CAAA;EACA,8BAAA;EACA,sCAAA;AJiUR;AI9TI;EACI,sCAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;EACA,YAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;AJgUR;AI7TI;EACI,4CAAA;EACA,sBAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;EACA,yBAAA;AJ+TR;AI5TI;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AJ8TR;AI3TI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AJ6TR;AI1TI;EACI,MAAA;EACA,OAAA;EACA,WAAA;EACA,gCAAA;EACA,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;AJ4TR;AIzTI;EACI,SAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,sCAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;AJ2TR;AIxTI;EACI,cAAA;EACA,aAAA;EACA,8BAAA;AJ0TR;AIxTI;EACI,YAAA;AJ0TR;AIvTI;EACI,kBAAA;EACA,OAAA;EACA,YAAA;AJyTR;AItTI;EACI,eAAA;EACA,4BAAA;AJwTR;AIrTI;EACI,sBAAA;AJuTR;AIpTI;EACI;IACI,uBAAA;IACA,+BAAA;IACA,4BAAA;IACA,2BAAA;IACA,0BAAA;EJsTV;EIpTM;IACI,mBAAA;IACA,2BAAA;IACA,wBAAA;IACA,uBAAA;IACA,sBAAA;EJsTV;EIpTM;IACI,uBAAA;IACA,+BAAA;IACA,4BAAA;IACA,2BAAA;IACA,0BAAA;EJsTV;EIpTM;IACI,mBAAA;IACA,2BAAA;IACA,wBAAA;IACA,uBAAA;IACA,sBAAA;EJsTV;AACF;;AIlTA;EACI;IACI,WAAA;IACA,aAAA;IACA,uBAAA;EJqTN;EIpTM;IACI,aAAA;EJsTV;EIpTM;IACI,UAAA;EJsTV;EInTM;IACI,aAAA;EJqTV;AACF;AKxgBA;EACI,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gDAAA;EACA,YAAA;AL0gBJ;;AKvgBA;EACI,aAAA;EACA,uBAAA;AL0gBJ;;AMrhBA;EACI,gCAAA;EACA,uBAAA;EACA,oCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;ANwhBJ;;AMthBA,sBAAA;AACA;EACI,kBAAA;EACA,sBAAA;ANyhBJ;;AMthBA;EACI,gBAAA;ANyhBJ;;AMthBA;EACI,kBAAA;EACA,kCAAA;EACA,mCAAA;EACA,2CAAA;EACA,gDAAA;EACA,4CAAA;EACA,wBAAA;EACA,aAAA;EACA,yBAAA;ANyhBJ;;AMthBA;EACI,kBAAA;ANyhBJ;;AMthBA;EACI,gBAAA;ANyhBJ;;AMthBA;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,0CAAA;EACA,2CAAA;EACA,wCAAA;EACA,kBAAA;EACA,sBAAA;ANyhBJ;;AMthBA;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,mEAAA;EACA,0EAAA;EACA,qHAAA;EAIA,oDAAA;ANshBJ;;AMnhBA;EACI,+BAAA;ANshBJ;;AMnhBA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,4EAAA;EAGA,2EAAA;EACA,iFAAA;EAGA,uEAAA;EACA,wEAAA;ANkhBJ;;AMhhBA;EACI,iBAAA;ANmhBJ;;AMhhBA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,4EAAA;EAGA,2EAAA;EACA,iFAAA;EAGA,uEAAA;EACA,wEAAA;AN+gBJ;;AM5gBA;EACI,uBAAA;EACA;kFAAA;EAEA,6DAAA;EACA,oEAAA;AN+gBJ;;AO9nBA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;APioBJ;;AO/nBA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EAGA,wBAAA;EACA,YAAA;APkoBJ;;AOhoBA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EAGA,qBAAA;EACA,qBAAA;APmoBJ;;AOjoBA;EACI,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EAIA,2BAAA;EAGA,4CAAA;APooBJ;;AOloBA;EAGI,oCAAA;APqoBJ;;AOnoBA;EAEI,qBAAA;EACA,yBAAA;APsoBJ;;AOpoBA;EAGI,qCAAA;APuoBJ;;AOroBA;EAEI,qBAAA;EACA,yBAAA;APwoBJ;;AOtoBA;EAGI,qCAAA;APyoBJ;;AOvoBA;EAEI,qBAAA;EACA,yBAAA;AP0oBJ;AOhjBA;EACI;IAII,8CAAA;IACA,kBAAA;IACA,eAAA;IACA,UAAA;EPgoBN;EO9nBE;IAII,2CAAA;IACA,kBAAA;IACA,eAAA;IACA,UAAA;EP+nBN;EO7nBE;IAII,6CAAA;IACA,kBAAA;IACA,eAAA;IACA,UAAA;EP8nBN;AACF;AO3nBA;EACI,gBAAA;EACA,YAAA;AP6nBJ;;AQn0BA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;ARs0BJ;;AQn0BA;EACI,UAAA;EACA,QAAA;EACA,SAAA;ARs0BJ;;AQn0BA;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EAEA,gBAAA;ARs0BJ;;AQn0BA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;ARs0BJ;;AQn0BA;EACI,yBNtCO;AF42BX;;AQn0BA;EACI,2BAAA;ARs0BJ;;AQn0BA;EAGI,2BAAA;ARs0BJ;;AQn0BA,oBAAA;AACA;EACI,mBAAA;ARs0BJ;;AQn0BA;EACI,kBAAA;ARs0BJ;;AS/3BA;EACI,wBAAA;ATk4BJ;;AS/3BA;EACI,yBAAA;EACA,YAAA;EAOA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AT43BJ;ASv4BI;EACI,UAAA;EACA,gBAAA;ATy4BR;;AS73BA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EAGA,8CAAA;ATg4BJ;AS93BI;EACI,cAAA;ATg4BR;AS73BI;EACI,cAAA;EACA,eAAA;AT+3BR;AS53BI;EACI,aAAA;EACA,6BAAA;EACA,YAAA;AT83BR;;AS13BA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EAIA,+CAAA;AT43BJ;AS13BI;EACI,YAAA;EACA,eAAA;AT43BR;ASz3BI;EACI,aAAA;EACA,6BAAA;EACA,YAAA;AT23BR;ASx3BI;EACI,cAAA;EACA,eAAA;AT03BR;ASv3BI;EACI,YAAA;EACA,eAAA;ATy3BR;ASt3BI;EACI,cAAA;EACA,eAAA;ATw3BR;;ASp3BA;EACI,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EAGA,kDAAA;EACA,WAAA;ATu3BJ;;AU39BA;EACI,mDAAA;AV89BJ;;AU39BA;EACI,mDAAA;AV89BJ;;AU39BA;EACI,iEAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,wEAAA;EACA,aAAA;EACA,iCAAA;EACA,YAAA;EACA,aAAA;EACA,qDAAA;EAEA,kCAAA;EACA,2BAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AV69BJ;;AU19BA;EACI,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AV69BJ;;AU19BA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AV69BJ;AU59BI;EACI,gBAAA;AV89BR;AU59BI;EACI,cAAA;EACA,cAAA;AV89BR;;AU19BA;EACI,aAAA;AV69BJ;;AUt9BA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AVy9BJ;AUx9BI;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AV09BR;;AUv9BA;EACI,aAAA;AV09BJ;;AUx9BA;EACI,aAAA;EACA,8BAAA;AV29BJ;;AUx9BA;EACI,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AV29BJ;AU19BI;EACI,UAAA;EACA,6BAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AV49BR;AU19BI;EACI,UAAA;AV49BR;;AUz9BA;EACI,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AV49BJ;AU39BI;EACI,UAAA;EACA,6BAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AV69BR;AU39BI;EACI,UAAA;AV69BR;;AUz9BA;EACI,UAAA;EACA,6BAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AV49BJ;;AU19BA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AV69BJ;;AU39BA;EACI,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AV89BJ;AU79BI;EAEI,6BAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AV89BR;;AU19BA;EACI,WAAA;EACA,6BAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AV69BJ;;AU19BA;EACI,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AV69BJ;;AU19BA;EACI,UAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AV69BJ;;AUx8BA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EAEA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AV28BJ;;AUx8BA;EACI,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AV28BJ;;AUx8BA;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AV28BJ;;AUx8BA;EACI;IACI,UAAA;EV28BN;EUz8BE;IACI,UAAA;EV28BN;EUz8BE;IACI,WAAA;EV28BN;EUz8BE;IACI,sBAAA;EV28BN;EUz8BE;IACI,WAAA;EV28BN;EUz8BE;IACI,sBAAA;EV28BN;AACF;AA9rCA;EACI,aAAA;AAgsCJ;AA/rCI;EACI,cAAA;AAisCR;AA9sCA;EAAA,2BA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,sBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,kBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,kBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,kBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,kBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,kBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,kBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,kBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,kBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA;AA8sCA;AA9sCA;EAAA;AA8sCA;AA9sCA;EAAA,4DA8sCA;EA9sCA,mEA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,4DA8sCA;EA9sCA,mEA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,4DA8sCA;EA9sCA,mEA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,4DA8sCA;EA9sCA,qEA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,4DA8sCA;EA9sCA,oEA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,sEA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA;AA8sCA;AA9sCA;EAAA;AA8sCA;AA9sCA;EAAA;AA8sCA;AA9sCA;EAAA;AA8sCA;AA9sCA;EAAA;AA8sCA;AA9sCA;EAAA,oBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,oBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,oBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,oBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,oBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,oBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,+EA8sCA;EA9sCA,mGA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,sBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,sBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,sBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,2GA8sCA;EA9sCA,yGA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,oBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,oBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA,oBA8sCA;EA9sCA;AA8sCA;AA9sCA;EAAA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA,qBA8sCA;IA9sCA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;AAAA;AA9sCA;EAAA;IAAA;EA8sCA;EA9sCA;IAAA,kBA8sCA;IA9sCA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;EA9sCA;IAAA;EA8sCA;AAAA;AA9sCA;EAAA;AA8sCA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import 'variables/_all';\n@import 'base/_all';\n\n@import 'page/page';\n@import 'elements/elements';\n\n#flowTree {\n    height: 100vh;\n    * {\n        direction: ltr;\n    }\n}\n","@import '../variables/_all.scss';\n\n* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    direction: rtl;\n}\n\nul,\nli {\n    list-style: none;\n}\n.custom-img {\n    object-fit: contain;\n    width: 100% !important;\n    position: relative !important;\n    height: unset !important;\n}\n\n.unset-img {\n    width: 100%;\n}\n.unset-img > div {\n    position: unset !important;\n}\nimg,\nvideo {\n    max-width: 100%;\n}\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n    display: block;\n    vertical-align: middle;\n}\n\na {\n    color: inherit;\n    text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    //font-size: inherit;\n    //font-weight: inherit;\n}\n\n.font-bold {\n    font-weight: 700;\n}\n\n.font-small {\n    font-size: 0.8em;\n}\n.font-big {\n    font-size: 1.2em;\n}\n\n.max-w-container {\n    max-width: 1366px;\n}\n\n\n\n.bd-10 {\n    border-radius: 10px;\n}\n\n.shadowBox {\n    -webkit-box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n    -moz-box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n}\n.shadowBoxInset {\n    -webkit-box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15) inset;\n    -moz-box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15) inset;\n    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15) inset;\n}\n\n*:focus {\n    outline: none;\n}\n\n.select_box {\n    width: 200px;\n    overflow: hidden;\n    border: 1px solid #000;\n    position: relative;\n    padding: 10px 0;\n}\n.select_box:after {\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid #f00;\n    position: absolute;\n    top: 40%;\n    right: 5px;\n    content: '';\n    z-index: 98;\n}\n.select_box select {\n    width: 220px;\n    border: 0;\n    position: relative;\n    z-index: 99;\n    background: none;\n}\n\n$border-color: $gray-clr;\n$accent-color: $main-clr;\n\n// Radio\n.radio {\n    display: inline-block;\n    position: relative;\n    margin: 0 0 10px;\n    font-size: 16px;\n    line-height: 24px;\n\n    &__input {\n        position: absolute;\n        top: 4px;\n        left: 0;\n        width: 36px;\n        height: 20px;\n        opacity: 0;\n        z-index: 0;\n    }\n\n    // Unchecked\n    &__label {\n        display: block;\n        padding: 0 0 0 24px;\n        cursor: pointer;\n\n        &:before {\n            content: '';\n            position: absolute;\n            top: 4px;\n            left: 0;\n            width: 16px;\n            height: 16px;\n            background-color: transparent;\n            border: 2px solid $border-color;\n            border-radius: 14px;\n            z-index: 1;\n            transition: border-color 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n        }\n\n        &:after {\n            content: '';\n            position: absolute;\n            top: 8px;\n            left: 4px;\n            width: 8px;\n            height: 8px;\n            background-color: $accent-color;\n            border-radius: 50%;\n            z-index: 2;\n            transform: scale(0, 0);\n            transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n        }\n    }\n\n    // Checked\n    &__input:checked + &__label {\n        &:before {\n            border-color: $accent-color;\n        }\n\n        &:after {\n            transform: scale(1, 1);\n        }\n    }\n\n    // Focus\n    // Uncomment for accessible outline\n    // &__input:focus + &__label {\n    //     &:before {\n    //         outline: 1px dotted currentColor;\n    //     }\n    // }\n}\n\n/* ===== Scrollbar CSS ===== */\n/* Firefox */\n* {\n    scrollbar-width: auto;\n    scrollbar-color: #0666e5 #ffffff;\n}\n\n/* Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n    width: 10px;\n}\n\n*::-webkit-scrollbar-track {\n    background: #ffffff;\n}\n\n*::-webkit-scrollbar-thumb {\n    background-color: #0666e5;\n    border-radius: 10px;\n    border: 3px solid #ffffff;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.w-50 {\n    width: 50%;\n}\n.w-25 {\n    width: 25%;\n}\n.w-75 {\n    width: 75%;\n}\n\n.border-none {\n    border: none;\n}\n\n.rmdp-container  {\n    width: 100%;\n}\n\n.react-flow__node-PositionNode {\n    width: auto !important;\n}","$main-clr: #3040e6;\n$main-disabled-clr: #a1a6e2;\n$main-low-clr: #e8eafd;\n$bg-low-clr: #f2f3ff;\n$green-clr: #0da717;\n$green-low-clr: #cffad6;\n$red-clr: #db0000;\n$yellow-clr: #ffbf00;\n$red-low-clr: #fbe5e5;\n$gray-clr: #9e9e9e;\n",".gray-clr {\n    color: $gray-clr;\n}\n.white-clr {\n    color: white;\n}\n\n.main-clr {\n    color: $main-clr;\n}\n\n.main-disabled-clr {\n    color: $main-disabled-clr;\n}\n\n.main-low-clr {\n    color: $main-low-clr;\n}\n\n.bg-low-clr {\n    color: $bg-low-clr;\n}\n\n.green-clr {\n    color: $green-clr;\n}\n\n.green-low-clr {\n    color: $green-low-clr;\n}\n\n.red-clr {\n    color: $red-clr;\n}\n.yellow-clr {\n    color: $yellow-clr;\n}\n\n.red-low-clr {\n    color: $red-low-clr;\n}\n\n.green-low-clr {\n    color: $green-low-clr;\n}\n\n.black-clr {\n    color: black;\n}\n\n.black-bg {\n    background-color: black;\n}\n\n.gray-clr-bg {\n    background-color: $gray-clr;\n}\n\n.main-clr-bg {\n    background-color: $main-clr;\n}\n\n.main-disabled-clr-bg {\n    background-color: $main-disabled-clr;\n}\n\n.main-low-clr-bg {\n    background-color: $main-low-clr;\n}\n\n.bg-low-clr-bg {\n    background-color: $bg-low-clr;\n}\n\n.green-clr-bg {\n    background-color: $green-clr;\n}\n\n.green-low-clr-bg {\n    background-color: $green-low-clr;\n}\n\n.red-clr-bg {\n    background-color: $red-clr;\n}\n\n.red-low-clr-bg {\n    background-color: $red-low-clr;\n}\n\n.green-low-clr-bg {\n    background-color: $green-low-clr;\n}\n\n.white-clr-bg {\n    background-color: white;\n}\n\n.yellow-clr-bg {\n    background-color: $yellow-clr;\n}\n",":root {\n    --background: #1a1a2e;\n    --color: #ffffff;\n    --primary-color: #0f3460;\n}\n\n.login {\n    a {\n        text-decoration: none;\n        color: var(--color);\n    }\n\n    h1 {\n        font-size: 2.5rem;\n    }\n\n    .container {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 100vh;\n    }\n\n    .login-container {\n        position: relative;\n        width: 22.2rem;\n    }\n    .form-container {\n        border: 1px solid hsla(0, 0%, 65%, 0.158);\n        box-shadow: 0 0 36px 1px rgba(0, 0, 0, 0.2);\n        border-radius: 10px;\n        backdrop-filter: blur(20px);\n        z-index: 99;\n        padding: 2rem;\n        -webkit-border-radius: 10px;\n        -moz-border-radius: 10px;\n        -ms-border-radius: 10px;\n        -o-border-radius: 10px;\n    }\n\n    .login-container form input {\n        display: block;\n        padding: 14.5px;\n        width: 100%;\n        margin: 2rem 0;\n        color: black;\n        outline: none;\n        background-color: #9191911f;\n        border: none;\n        border-radius: 5px;\n        font-weight: 500;\n        letter-spacing: 0.8px;\n        font-size: 15px;\n        backdrop-filter: blur(15px);\n        -webkit-border-radius: 5px;\n        -moz-border-radius: 5px;\n        -ms-border-radius: 5px;\n        -o-border-radius: 5px;\n    }\n\n    .login-container form input:focus {\n        box-shadow: 0 0 16px 1px rgba(0, 0, 0, 0.2);\n        animation: wobble 0.3s ease-in;\n        -webkit-animation: wobble 0.3s ease-in;\n    }\n\n    .login-container form button {\n        background-color: var(--primary-color);\n        color: var(--color);\n        display: block;\n        padding: 13px;\n        border-radius: 5px;\n        outline: none;\n        font-size: 18px;\n        letter-spacing: 1.5px;\n        font-weight: bold;\n        width: 100%;\n        cursor: pointer;\n        margin-bottom: 2rem;\n        transition: all 0.1s ease-in-out;\n        border: none;\n        -webkit-border-radius: 5px;\n        -moz-border-radius: 5px;\n        -ms-border-radius: 5px;\n        -o-border-radius: 5px;\n        -webkit-transition: all 0.1s ease-in-out;\n        -moz-transition: all 0.1s ease-in-out;\n        -ms-transition: all 0.1s ease-in-out;\n        -o-transition: all 0.1s ease-in-out;\n    }\n\n    .login-container form button:hover {\n        box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.15);\n        transform: scale(1.02);\n        -webkit-transform: scale(1.02);\n        -moz-transform: scale(1.02);\n        -ms-transform: scale(1.02);\n        -o-transform: scale(1.02);\n    }\n\n    .circle {\n        width: 8rem;\n        height: 8rem;\n        background: var(--primary-color);\n        border-radius: 50%;\n        -webkit-border-radius: 50%;\n        -moz-border-radius: 50%;\n        -ms-border-radius: 50%;\n        -o-border-radius: 50%;\n        position: absolute;\n    }\n\n    .illustration {\n        position: absolute;\n        top: -14%;\n        right: -2px;\n        width: 90%;\n    }\n\n    .circle-one {\n        top: 0;\n        left: 0;\n        z-index: -1;\n        transform: translate(-45%, -45%);\n        -webkit-transform: translate(-45%, -45%);\n        -moz-transform: translate(-45%, -45%);\n        -ms-transform: translate(-45%, -45%);\n        -o-transform: translate(-45%, -45%);\n    }\n\n    .circle-two {\n        bottom: 0;\n        right: 0;\n        z-index: -1;\n        transform: translate(45%, 45%);\n        -webkit-transform: translate(45%, 45%);\n        -moz-transform: translate(45%, 45%);\n        -ms-transform: translate(45%, 45%);\n        -o-transform: translate(45%, 45%);\n    }\n\n    .register-forget {\n        margin: 1rem 0;\n        display: flex;\n        justify-content: space-between;\n    }\n    .opacity {\n        opacity: 0.6;\n    }\n\n    .theme-btn-container {\n        position: absolute;\n        left: 0;\n        bottom: 2rem;\n    }\n\n    .theme-btn {\n        cursor: pointer;\n        transition: all 0.3s ease-in;\n    }\n\n    .theme-btn:hover {\n        width: 40px !important;\n    }\n\n    @keyframes wobble {\n        0% {\n            transform: scale(1.025);\n            -webkit-transform: scale(1.025);\n            -moz-transform: scale(1.025);\n            -ms-transform: scale(1.025);\n            -o-transform: scale(1.025);\n        }\n        25% {\n            transform: scale(1);\n            -webkit-transform: scale(1);\n            -moz-transform: scale(1);\n            -ms-transform: scale(1);\n            -o-transform: scale(1);\n        }\n        75% {\n            transform: scale(1.025);\n            -webkit-transform: scale(1.025);\n            -moz-transform: scale(1.025);\n            -ms-transform: scale(1.025);\n            -o-transform: scale(1.025);\n        }\n        100% {\n            transform: scale(1);\n            -webkit-transform: scale(1);\n            -moz-transform: scale(1);\n            -ms-transform: scale(1);\n            -o-transform: scale(1);\n        }\n    }\n}\n\n@media (max-width: 600px) {\n    .login {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        .circle {\n            display: none;\n        }\n        .container {\n            width: 80%;\n        }\n\n        .form-container {\n            padding: 1rem;\n        }\n    }\n}\n",".input {\n    background-color: white;\n    border: 1px solid #f1f1f1;\n    color: black;\n    border-radius: 5px;\n    box-shadow: 0px 0px 15px 5px rgb(0 0 0 / 4%);\n    padding: 5px;\n}\n\n.input-td {\n    display: flex;\n    justify-content: center;\n}\n",":root {\n    --body-background-color: #e5f4ff;\n    --v-progress-left: 50px;\n    --v-progress-item-height-width: 12px;\n    --v-progress-line-height: 35px;\n    --v-progress-line-width: 3px;\n    --v-progress-gap: 13px;\n    --blue: #0081c9;\n    --green: #159895;\n    --light-blue: #5bc0f8;\n}\n/* vertical progress */\n.v-progress {\n    width: fit-content;\n    padding: 10px 0 10px 0;\n}\n\n.v-progress ul {\n    list-style: none;\n}\n\n.v-progress-item {\n    position: relative;\n    /* left: var(--v-progress-left); */\n    margin-left: var(--v-progress-left);\n    height: var(--v-progress-item-height-width);\n    line-height: var(--v-progress-item-height-width);\n    margin-bottom: var(--v-progress-line-height);\n    --v-progress-border: 8px;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.v-progress-item:last-child {\n    margin-bottom: 0px;\n}\n\n.v-progress-item:last-child:after {\n    border-left: 0px;\n}\n\n.v-progress-item:before {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    width: var(--v-progress-item-height-width);\n    height: var(--v-progress-item-height-width);\n    left: calc(0px - var(--v-progress-left));\n    border-radius: 50%;\n    background-color: #ccc;\n}\n\n.v-progress-item:after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    height: calc(var(--v-progress-line-height) - var(--v-progress-gap));\n    top: calc(var(--v-progress-item-height-width) + var(--v-progress-gap) / 2);\n    left: calc(\n        0px - var(--v-progress-left) + var(--v-progress-item-height-width) /\n            2 - var(--v-progress-line-width) / 2\n    );\n    border-left: var(--v-progress-line-width) solid #ccc;\n}\n\n.v-progress-item.completed:after {\n    border-color: var(--light-blue);\n}\n\n.v-progress-item.completed:before {\n    content: '✔';\n    font-size: 11px;\n    text-align: center;\n    color: white;\n    background: var(--light-blue);\n    height: calc(\n        var(--v-progress-border) + var(--v-progress-item-height-width)\n    );\n    width: calc(var(--v-progress-border) + var(--v-progress-item-height-width));\n    line-height: calc(\n        var(--v-progress-border) + var(--v-progress-item-height-width)\n    );\n    left: calc(0px - var(--v-progress-left) - var(--v-progress-border) / 2);\n    top: calc(0px - var(--v-progress-border) + var(--v-progress-border) / 2);\n}\n.v-progress-item.cancel:after {\n    border-color: red;\n}\n\n.v-progress-item.cancel:before {\n    content: '✖';\n    font-size: 11px;\n    text-align: center;\n    color: white;\n    background: #ff9f9f;\n    height: calc(\n        var(--v-progress-border) + var(--v-progress-item-height-width)\n    );\n    width: calc(var(--v-progress-border) + var(--v-progress-item-height-width));\n    line-height: calc(\n        var(--v-progress-border) + var(--v-progress-item-height-width)\n    );\n    left: calc(0px - var(--v-progress-left) - var(--v-progress-border) / 2);\n    top: calc(0px - var(--v-progress-border) + var(--v-progress-border) / 2);\n}\n\n.v-progress-item.inprogress:before {\n    background-color: white;\n    /*   height: calc(var(--v-progress-border) + var(--v-progress-item-height-width));\n      width: calc(var(--v-progress-border) + var(--v-progress-item-height-width)); */\n    outline: calc(var(--v-progress-border) / 2) solid var(--blue);\n    top: calc(0px - var(--v-progress-border) + var(--v-progress-border));\n}\n","#loader {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: #275efe;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    flex-direction: column;\n}\n.cube-folding {\n    width: 50px;\n    height: 50px;\n    display: inline-block;\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    transform: rotate(45deg);\n    font-size: 0;\n}\n.cube-folding span {\n    position: relative;\n    width: 25px;\n    height: 25px;\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    transform: scale(1.1);\n    display: inline-block;\n}\n.cube-folding span::before {\n    content: '';\n    background-color: white;\n    position: absolute;\n    left: 0;\n    top: 0;\n    display: block;\n    width: 25px;\n    height: 25px;\n    -moz-transform-origin: 100% 100%;\n    -ms-transform-origin: 100% 100%;\n    -webkit-transform-origin: 100% 100%;\n    transform-origin: 100% 100%;\n    -webkit-animation: folding 2.5s infinite linear both;\n    -moz-animation: folding 2.5s infinite linear both;\n    animation: folding 2.5s infinite linear both;\n}\n.cube-folding .leaf2 {\n    -webkit-transform: rotateZ(90deg) scale(1.1);\n    -moz-transform: rotateZ(90deg) scale(1.1);\n    transform: rotateZ(90deg) scale(1.1);\n}\n.cube-folding .leaf2::before {\n    -webkit-animation-delay: 0.3s;\n    animation-delay: 0.3s;\n    background-color: #f2f2f2;\n}\n.cube-folding .leaf3 {\n    -webkit-transform: rotateZ(270deg) scale(1.1);\n    -moz-transform: rotateZ(270deg) scale(1.1);\n    transform: rotateZ(270deg) scale(1.1);\n}\n.cube-folding .leaf3::before {\n    -webkit-animation-delay: 0.9s;\n    animation-delay: 0.9s;\n    background-color: #f2f2f2;\n}\n.cube-folding .leaf4 {\n    -webkit-transform: rotateZ(180deg) scale(1.1);\n    -moz-transform: rotateZ(180deg) scale(1.1);\n    transform: rotateZ(180deg) scale(1.1);\n}\n.cube-folding .leaf4::before {\n    -webkit-animation-delay: 0.6s;\n    animation-delay: 0.6s;\n    background-color: #e6e6e6;\n}\n\n@-webkit-keyframes folding {\n    0%,\n    10% {\n        -webkit-transform: perspective(140px) rotateX(-180deg);\n        -moz-transform: perspective(140px) rotateX(-180deg);\n        transform: perspective(140px) rotateX(-180deg);\n        -webkit-opacity: 0;\n        -moz-opacity: 0;\n        opacity: 0;\n    }\n    25%,\n    75% {\n        -webkit-transform: perspective(140px) rotateX(0deg);\n        -moz-transform: perspective(140px) rotateX(0deg);\n        transform: perspective(140px) rotateX(0deg);\n        -webkit-opacity: 1;\n        -moz-opacity: 1;\n        opacity: 1;\n    }\n    90%,\n    100% {\n        -webkit-transform: perspective(140px) rotateY(180deg);\n        -moz-transform: perspective(140px) rotateY(180deg);\n        transform: perspective(140px) rotateY(180deg);\n        -webkit-opacity: 0;\n        -moz-opacity: 0;\n        opacity: 0;\n    }\n}\n@-moz-keyframes folding {\n    0%,\n    10% {\n        -webkit-transform: perspective(140px) rotateX(-180deg);\n        -moz-transform: perspective(140px) rotateX(-180deg);\n        transform: perspective(140px) rotateX(-180deg);\n        -webkit-opacity: 0;\n        -moz-opacity: 0;\n        opacity: 0;\n    }\n    25%,\n    75% {\n        -webkit-transform: perspective(140px) rotateX(0deg);\n        -moz-transform: perspective(140px) rotateX(0deg);\n        transform: perspective(140px) rotateX(0deg);\n        -webkit-opacity: 1;\n        -moz-opacity: 1;\n        opacity: 1;\n    }\n    90%,\n    100% {\n        -webkit-transform: perspective(140px) rotateY(180deg);\n        -moz-transform: perspective(140px) rotateY(180deg);\n        transform: perspective(140px) rotateY(180deg);\n        -webkit-opacity: 0;\n        -moz-opacity: 0;\n        opacity: 0;\n    }\n}\n@-ms-keyframes folding {\n    0%,\n    10% {\n        -webkit-transform: perspective(140px) rotateX(-180deg);\n        -moz-transform: perspective(140px) rotateX(-180deg);\n        transform: perspective(140px) rotateX(-180deg);\n        -webkit-opacity: 0;\n        -moz-opacity: 0;\n        opacity: 0;\n    }\n    25%,\n    75% {\n        -webkit-transform: perspective(140px) rotateX(0deg);\n        -moz-transform: perspective(140px) rotateX(0deg);\n        transform: perspective(140px) rotateX(0deg);\n        -webkit-opacity: 1;\n        -moz-opacity: 1;\n        opacity: 1;\n    }\n    90%,\n    100% {\n        -webkit-transform: perspective(140px) rotateY(180deg);\n        -moz-transform: perspective(140px) rotateY(180deg);\n        transform: perspective(140px) rotateY(180deg);\n        -webkit-opacity: 0;\n        -moz-opacity: 0;\n        opacity: 0;\n    }\n}\n@keyframes folding {\n    0%,\n    10% {\n        -webkit-transform: perspective(140px) rotateX(-180deg);\n        -moz-transform: perspective(140px) rotateX(-180deg);\n        transform: perspective(140px) rotateX(-180deg);\n        -webkit-opacity: 0;\n        -moz-opacity: 0;\n        opacity: 0;\n    }\n    25%,\n    75% {\n        -webkit-transform: perspective(140px) rotateX(0deg);\n        -moz-transform: perspective(140px) rotateX(0deg);\n        transform: perspective(140px) rotateX(0deg);\n        -webkit-opacity: 1;\n        -moz-opacity: 1;\n        opacity: 1;\n    }\n    90%,\n    100% {\n        -webkit-transform: perspective(140px) rotateY(180deg);\n        -moz-transform: perspective(140px) rotateY(180deg);\n        transform: perspective(140px) rotateY(180deg);\n        -webkit-opacity: 0;\n        -moz-opacity: 0;\n        opacity: 0;\n    }\n}\n\n.text-loading {\n    margin-top: 50px;\n    color: white;\n}\n",".switch {\n    position: relative;\n    display: inline-block;\n    width: 60px;\n    height: 34px;\n}\n\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n}\n\n.slider:before {\n    position: absolute;\n    content: '';\n    height: 26px;\n    width: 26px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n}\n\ninput:checked + .slider {\n    background-color: $main-clr;\n}\n\ninput:focus + .slider {\n    box-shadow: 0 0 1px $main-clr;\n}\n\ninput:checked + .slider:before {\n    -webkit-transform: translateX(26px);\n    -ms-transform: translateX(26px);\n    transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n    border-radius: 34px;\n}\n\n.slider.round:before {\n    border-radius: 50%;\n}\n","#flowTree {\n    height: 100vh !important;\n}\n\n.edge-custom {\n    background-color: #ff8383;\n    color: white;\n\n    svg {\n        color: red;\n        margin-left: 5px;\n    }\n\n    border: 1px solid red;\n    border-radius: 10px;\n    padding: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 8px;\n}\n\n.positionNode {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 100%;\n    background-color: #ffc709;\n    border-radius: 15px;\n    padding: 10px;\n    -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);\n    -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);\n    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);\n\n    .positionNode-label {\n        color: #321515;\n    }\n\n    .positionNode-trash {\n        color: #e82703;\n        cursor: pointer;\n    }\n\n    .positionNode-box-icons {\n        display: flex;\n        justify-content: space-around;\n        width: 100px;\n    }\n}\n\n.departmentNode {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 100%;\n    background-color: #1736f5;\n    border-radius: 15px;\n    padding: 10px;\n\n    -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.65);\n    -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.65);\n    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.65);\n\n    .departmentNode-label {\n        color: white;\n        cursor: pointer;\n    }\n\n    .departmentNode-box-icons {\n        display: flex;\n        justify-content: space-around;\n        width: 100px;\n    }\n\n    .departmentNode-trash {\n        color: #e82703;\n        cursor: pointer;\n    }\n\n    .departmentNode-department {\n        color: white;\n        cursor: pointer;\n    }\n\n    .departmentNode-position {\n        color: #ffc709;\n        cursor: pointer;\n    }\n}\n\n.axis-flow-btn {\n    background-color: white;\n    border: 1px solid #cdcdcd;\n    border-radius: 10px;\n    padding: 5px;\n    -webkit-box-shadow: 0px 0px 5px 0px rgba(90, 90, 90, 0.45);\n    -moz-box-shadow: 0px 0px 5px 0px rgba(90, 90, 90, 0.45);\n    box-shadow: 0px 0px 5px 0px rgba(90, 90, 90, 0.45);\n    margin: 8px;\n}\n",".ReactModal__Overlay {\n    background-color: rgba(255, 255, 255, 0) !important;\n}\n\n.ReactModalPortal:nth-child(1) {\n    background-color: rgba(255, 255, 255, 0) !important;\n}\n\n.modal-option {\n    /* fixed position will always show modal in the top left corner */\n    position: fixed;\n    top: 0;\n    left: 0;\n    /* z-index to show modal even if it is used before some other elements */\n    z-index: 1000;\n    /* make modal fill whole window */\n    width: 100vw;\n    height: 100vh;\n    /* add some background to blur content behind modal */\n    // background: rgba(255, 255, 255, 0.8);\n    background: rgba(255, 255, 255, 0);\n    backdrop-filter: blur(10px);\n    /* center content inside modal */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.compoenent-modal-option {\n    background-color: black;\n    border: 1px solid gold;\n    border-radius: 20px;\n    max-width: 1366px;\n    width: 50%;\n}\n\n.modal-option-topbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 5px 20px;\n    h1 {\n        font-size: 1.1em;\n    }\n    svg {\n        color: #6800ff;\n        font-size: 2em;\n    }\n}\n\n.modal-content {\n    padding: 20px;\n}\n\n.form-modal-content {\n    // padding: 10px;\n}\n\n.box-input-form-modal-content-100 {\n    width: 100%;\n    display: flex;\n    margin-bottom: 15px;\n    input {\n        width: 100%;\n        margin-right: 10px;\n        margin-left: 10px;\n        background-color: transparent;\n        border: 1px solid gold;\n        border-radius: 10px;\n        padding: 7px;\n    }\n}\n.container-box-input-form-modal-content-50 {\n    display: flex;\n}\n.container-box-input-form-modal-content-30 {\n    display: flex;\n    justify-content: space-between;\n}\n\n.box-input-form-modal-content-50 {\n    width: 50%;\n    padding-right: 10px;\n    padding-top: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    input {\n        width: 92%;\n        background-color: transparent;\n        border: 1px solid gold;\n        border-radius: 10px;\n        height: 38px;\n        padding: 7px;\n    }\n    button {\n        width: 92%;\n    }\n}\n.box-input-form-modal-content-30 {\n    width: 30%;\n    padding-right: 10px;\n    padding-top: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    input {\n        width: 92%;\n        background-color: transparent;\n        border: 1px solid gold;\n        border-radius: 10px;\n        height: 38px;\n        padding: 7px;\n    }\n    button {\n        width: 92%;\n    }\n}\n\n.textareaInputStyle {\n    width: 92%;\n    background-color: transparent;\n    border: 1px solid gold;\n    border-radius: 10px;\n    height: 38px;\n    padding: 7px;\n    resize: vertical;\n    color: gold;\n}\n.box-inputs-auto {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n.box-input-form-modal-content-auto {\n    margin: 10px;\n    padding-right: 10px;\n    padding-top: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    input {\n        // width: 92%;\n        background-color: transparent;\n        border: 1px solid gold;\n        border-radius: 10px;\n        height: 38px;\n        padding: 7px;\n    }\n}\n\n.btn-modal-option-cancel {\n    width: 101%;\n    background-color: transparent;\n    border: 1px solid gold;\n    border-radius: 5px;\n    color: gold;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding: 5px;\n}\n\n.btn-modal-option-ok {\n    width: 101%;\n    background-color: gold;\n    border: 1px solid gold;\n    border-radius: 5px;\n    color: black;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding: 5px;\n}\n\n.btn-modal-50 {\n    width: 92%;\n    background-color: gold;\n    border: 1px solid gold;\n    border-radius: 5px;\n    color: black;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding: 5px;\n}\n\n//////////////////////////////////////////////////\n///\n///\n///\n///\n///\n///\n///\n///\n///\n///\n///\n///\n///\n///\n///\n///\n\n.modal-components-background {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(255, 255, 255, 0);\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: auto;\n}\n\n.modal-components-warpper {\n    background-color: #f5f3ff;\n    border: 1px solid #6c00f3;\n    border-radius: 20px;\n    max-width: 1366px;\n    width: 100%;\n    overflow: auto;\n    max-height: 80vh;\n}\n\n.modal-components-background-content {\n    width: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@media all and (max-width: 1024px) {\n    .modal-components-background-content {\n        width: 90%;\n    }\n    .compoenent-modal-option {\n        width: 90%;\n    }\n    .box-input-form-modal-content-50 {\n        width: 100%;\n    }\n    .container-box-input-form-modal-content-50 {\n        flex-direction: column;\n    }\n    .box-input-form-modal-content-30 {\n        width: 100%;\n    }\n    .container-box-input-form-modal-content-30 {\n        flex-direction: column;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
